// namespace:
var agi = agi || {};
agi.expressions = agi.expressions || {};

(function(Utils, ExpressEvent, EventDispatcher, JLConfig) {
    "use strict";
    /**
     * @class Expression
     * @constructor
     *
     * TODO separate BrightCove so the VideoLoader
     * can be used independently.
     * based on ivex/videoadapter.js
     */
    function BrightCoveVideoLoader(opts) {
        this.initialize(opts);
    };

    var p = BrightCoveVideoLoader.prototype = new EventDispatcher();

    // public methods:
    /**
     * Initialization method.
     * @method initialize
     * @param {Object} opts Options to configure the video, including playlist
     */
    p.initialize = function initialize(opts) {
        this.options = {
            containerId: 'expression-vid-player',
            videoData: {},
            notifyUnexpectedPauseOnly: true,
            videoId: 'agi-video'
        };

        this.duration = 0;
        this.video = null;
        this.player = null;
        this.playerEvents = ['timeupdate', 'seeked', 'ended', 'error',
                             'fullscreenchange'];

        this.container = document.getElementById(this.options.containerId);
        this.container.style.position = "absolute";
        this.container.style.width = "100%";
        this.container.style.height = "100%";
        this.container.style.left = "0px";
        this.container.style.top = "0px";
        this.container.style.right = "0px";

        this.options = Utils.extend(this.options, opts);
        this.setupVideo();
    };

    /**
     * Create video element and attach it to DOM and
     * add event handlers to various video events.
     * @method setupVideo
     */
    p.setupVideo = function setupVideo() {
        var video = document.getElementById(this.options.videoId);
        // Customize the video size and layout
        video.controls = true;
        video.loop = false;
        video.autoplay = false;
        video.preload = "auto";
        video.style.width = "100%";
        video.style.height = "85.71%";
        video.style.marginTop = "0";
        video.style.outline = "none";

        // BrightCove specific
        var videoData = JSON.parse(this.options.videoData);
        var src = "//players.brightcove.net/" +
            JLConfig.videoAccount + "/" +
            JLConfig.videoPlayer +
            "_default/index.min.js";

        Utils.loadJavaScriptFile(src, this.successHandler.bind(this),
                this.failureHandler.bind(this));

        this.video = video;
    };

    //Loaded video player success
    p.successHandler = function successHandler() {
        this.player = this.getBrightcovePlayer();
        this.addPlayerListeners();

        this.dispatchStateUpdate("READY");
    };

    /* Return the Brightcove Player object. Later, methods will
        be directly called on this object (ex. exiting fullscreen).
        If not found, return ``undefined``.
    */
    p.getBrightcovePlayer = function getBrightcovePlayer() {
        try {
            return vjs.players[this.options.videoId];
        } catch (err) {
            return undefined;
        }
    };

    p.addPlayerListeners = function addPlayerListeners() {
        if (!this.player) {
            return;
        }

        for (var i=0; i<this.playerEvents.length; i++) {
            var event = this.playerEvents[i];
            this.player.on(event, this.handleEvent.bind(this));
        }
    };

    //If loading the player resulted in failure
    p.failureHandler = function failureHandler() {
        console.error("Sorry, an unexpected error occurred. Please try again");
    };

    //Called from JLVideo to fade in the video
    p.showVideo = function showVideo() {
        this.container.style.visibility = "visible";
	    this.container.style.display = "block";
	    TweenLite.to(this.container, 1,
            {alpha: 1, onComplete: this.onFadeInVideoComplete.bind(this)});
    };

    //Called from JLVideo to hide the video on end or skip
    p.hideVideo = function hideVideo() {
        this.pause();

        if (this.player.isFullscreen()) {
            this.player.exitFullscreen();
        }

        TweenLite.to(this.container, 1,
            {alpha: 0, onComplete: this.onFadeOutComplete.bind(this)});
    };

    //Auto play on fade in
    p.onFadeInVideoComplete = function onFadeInVideoComplete() {
        // Force play video for iOS
        if (this.player.paused()) {
            this.player.play();
        }
    }

    //Hide this container one we have totally faded out
    p.onFadeOutComplete = function onFadeOutVideoComplete() {
        this.container.style.visibility = "hidden";
    }

    /**
     * Play video
     */
    p.play = function play() {
        this.player.play();
    };

    /**
     * Seek to a specifc time and then play video
     * @param {Number} seekToTime Time to seek
     */
    p.seekAndPlay = function seekAndPlay(seekToTime) {
        this.player.currentTime(seekToTime);
        if (this.player.paused()) {
            this.player.play();
        }
    };

    /**
     * Pause video
     */
    p.pause = function pause() {
        this.player.pause();
    };

    /**
     * Destroy the instance, including removing the video from the DOM
     */
    p.destroy = function destroy() {
        this.removePlayerListeners();

        var videoEl = document.getElementById(this.options.videoId);
        if (videoEl) {
            videoEl.parentNode.removeChild(videoEl);
        }

        this.video = null;
        this.player = null;
    };

    p.removePlayerListeners = function removePlayerListeners() {
        if (!this.player) {
            return;
        }

        for (var i=0; i<this.playerEvents.length; i++) {
            var event = this.playerEvents[i];
            this.player.off(event);
        }
    };

    // private functions
    /**
     * Broadcast video-time-update event to its listeners
     */
    p.dispatchTimeUpdate = function dispatchTimeUpdate() {
        if (this.video) {
            var event = new ExpressEvent("videoTimeUpdate");
            event.data = {time: this.player.currentTime()};
            this.dispatchEvent(event);
        }
    };

    /**
     * Broadcast video-state-update event to its listeners
     */
    p.dispatchStateUpdate = function dispatchStateUpdate(state) {
        var event = new ExpressEvent("videoStateUpdate");
        event.data = {state: state};
        this.dispatchEvent(event);
    };

    /**
     * Broadcast video-error event to its listeners
     */
    p.dispatchError = function dispatchError(errMsg) {
        var event = new ExpressEvent("videoError");
        event.data = {error: errMsg};
        this.dispatchEvent(event);
    };

    /**
      * When in fullscreen, use the overlay image for the
      * video's poster image.
      *
      * The image changes based on screen size, so this ensures
      * that we use the correct one.
      */
    p.updatePosterImage = function updatePosterImage() {
        if (!this.player.isFullscreen()) {
            return;
        }

        var overlay = this.getOverlayImagePath();
        var poster = this.player.poster();

        if (overlay && overlay != poster) {
            this.player.poster(overlay);
        }
    };

    p.getOverlayImagePath = function getOverlayImagePath() {
        var imagePathPattern = /url\(["'](.*)["']\)/;

        var overlayNode = document.getElementById('expression-overlay');
        var overlayImage = window.getComputedStyle(
            overlayNode).backgroundImage;

        // strip out 'url("...")'
        var matches = overlayImage.match(imagePathPattern);

        if (matches && matches.length >= 2) {
            // background image URL
            return matches[1];
        }
    }


    p.handleEvent = function handleEvent(event) {
        switch (event.type) {
            case "error":
                this.dispatchError(event.message);
                break;

            case "timeupdate":
                this.dispatchTimeUpdate();
                break;

            case "ended":
                this.dispatchStateUpdate('COMPLETE');
                break;

            case "seeked":
                this.play();
                break;

            case "fullscreenchange":
                this.dispatchStateUpdate('SCREEN_CHANGE');
                this.updatePosterImage();
                break;
        };
    };

    agi.expressions.BrightCoveVideoLoader = BrightCoveVideoLoader;
})(agi.expressions.Utils, agi.expressions.ExpressEvent, createjs.EventDispatcher, agi.expressions.JLConfig);
